// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Wrapper the page \`<ViewTransition>\` snapshots (it needs a real box, so not \`display: contents\`). It stays a link of
 * the root flex column (#root → .pageWrapper → .page → root VerticalLayout, each \`flex: 1\`), so a root layout still
 * fills the viewport.
 */
.pageTransition-module_page__EIRYq {
    display: flex;
    flex-direction: column;
    flex: 1;
}

/*
 * React snapshots this wrapper, not the whole screen. While a transition runs it fills the viewport with the page
 * background, so a short page still covers the one underneath, like a full screen does. \`--page-transition-bg\` is set
 * by the resolver.
 */
html:active-view-transition .pageTransition-module_page__EIRYq {
    min-height: 100dvh;
    background: var(--page-transition-bg);
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/pageTransition/pageTransition.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;;;;EAIE;AACF;IACI,kBAAkB;IAClB,qCAAqC;AACzC","sourcesContent":["/*\n * Wrapper the page `<ViewTransition>` snapshots (it needs a real box, so not `display: contents`). It stays a link of\n * the root flex column (#root → .pageWrapper → .page → root VerticalLayout, each `flex: 1`), so a root layout still\n * fills the viewport.\n */\n.page {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n/*\n * React snapshots this wrapper, not the whole screen. While a transition runs it fills the viewport with the page\n * background, so a short page still covers the one underneath, like a full screen does. `--page-transition-bg` is set\n * by the resolver.\n */\n:global(html:active-view-transition) .page {\n    min-height: 100dvh;\n    background: var(--page-transition-bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `pageTransition-module_page__EIRYq`
};
export default ___CSS_LOADER_EXPORT___;
